<template>
 <div class="box1"></div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box1{
   background: url("../../../assets/coursePage/llm/box1/banner.png") no-repeat;
  background-size: cover;
  height:800px;
}
</style>
